// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qw-0";